import { useGetAllPersons } from '@hr/api/endpoints'
import { IconPersonnelCount } from '@hr/common/icons'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'

export function PersonnelCountSalary() {
	const { t } = useTranslation()
	const { data: persons } = useGetAllPersons()

	const countEmployed = () => {
		let male = 0
		let female = 0
		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const g = (person.gender || '').trim().toUpperCase()
				if (g === 'M') ++male
				else if (g === 'N') ++female
			}
		})

		const total = male + female
		if (total === 0) return

		return (
			<>
				<h4 className={styles.cardHeader}>{t('PersonnelCount', 'Henkilöstömäärä')}</h4>
				<IconPersonnelCount />
				<b className={styles.bigFigure}>{total}</b>
			</>
		)
	}

	return persons ? countEmployed() : <LoadingContainer />
}
